import { handleAPI, API_VERSION_ONE } from '../../../itrust_common/utils/apiUtils';

export function labOrderLoad(id, filters) {
  const url = `/${API_VERSION_ONE}/lab_orders/${id}`;
  const method = 'GET'

  return {
    type: 'LAB_ORDER_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function labOrderUpdate(data, filters) {
  const url = `/${API_VERSION_ONE}/lab_orders/${data.id}`;
  const method = "PUT"

  return {
    type: 'LAB_ORDER_UPDATE',
    payload: handleAPI(url, filters, method, { lab_order: { ...data } })
  }
}

export function labOrderCreate(data, filters) {
  const url = `/${API_VERSION_ONE}/lab_orders`;
  const method = "POST"

  return {
    type: 'LAB_ORDER_CREATE',
    payload: handleAPI(url, filters, method, { lab_order: { ...data } })
  }
}

// export function labOrderDownload(id, filters) {
//   const url = `/${API_VERSION_ONE}/lab_orders/${id}/download_pdf`;
//   const method = 'GET'

//   return {
//     type: 'LAB_ORDER_DOWNLOAD',
//     payload: handleAPI(url, filters, method)
//   };
// }

export function labOrderBarcodeScan(filters) {
  const url = `/${API_VERSION_ONE}/lab_orders/barcode_scan`;
  const method = 'GET'

  return {
    type: 'LAB_ORDER_BARCODE_SCAN',
    payload: handleAPI(url, filters, method)
  };
}

export function sendToVisionWebCreate(data, filters) {
  const url = `/${API_VERSION_ONE}/lab_orders`;
  const method = "POST"

  return {
    type: 'SEND_TO_VISION_WEB_CREATE',
    payload: handleAPI(url, filters, method, { lab_order: { ...data } })
  }
}

export function labOrderEdit(id) {
  return {
    type: 'LAB_ORDER_EDIT',
    id
  };
}

export function labOrderEditCancel() {
  return {
    type: 'LAB_ORDER_EDIT_CANCEL'
  };
}
